import React from 'react';
import { Link } from 'react-router-dom';

import './ProfileButton.css';

const ProfileButton = (props) => {
  return (
    <Link
      className='account-button'
      to={props.to}
      exact={props.exact}
      onClick={props.onClick}
    >
      {/* <div className='icon'></div> */}
      <p>{props.text}</p>
    </Link>
  );
};

export default ProfileButton;
